import * as React from 'react';
import styled from 'styled-components';

export interface IValidationMessage {
  message: string;
}

const StyledValidationMessage = styled.div`
  display: grid;
  gap: 4px;
  grid-template-columns: 60px 1fr;
`;

const StyledValidationTag = styled.span`
  border: solid 1px ${(props) => props.theme.colors.errorBorder};
  border-radius: ${(props) => props.theme.spacing.spacing2};
  color: ${(props) => props.theme.colors.errorText};
  padding: 0 4px;
`;

export const ValidationMessage = ({ message }: IValidationMessage) => (
  <StyledValidationMessage>
    <StyledValidationTag>ERROR</StyledValidationTag>
    <span>{message}</span>
  </StyledValidationMessage>
);
